// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__140Q3","name":"Header_name__3-zqD","birthday":"Header_birthday__1pSox","skeleton":"Header_skeleton__SaHn5"};